module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "c-navbar"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": _vm.goBack
    }
  }, [_c('div', {
    staticClass: "back-icon"
  }), _vm._v(" "), _c('div', [_vm._v("返回")])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right", [(_vm.showAboutMe) ? [_c('span', {
    staticClass: "user-center",
    on: {
      "click": _vm.openAboutMe
    }
  })] : _vm._e(), _vm._v(" "), (_vm.share) ? [_c('span', {
    staticClass: "share",
    on: {
      "click": _vm.shareClick
    }
  })] : _vm._e()])], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61df4a81","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-navbar/index.vue
// module id = 1056
// module chunks = 2